import { ReactNode } from 'react';

export const enum ProfileMenuOptionValue {
  Profile = 'profile',
  Theme = 'theme',
  Logout = 'logout',
  Login = 'login',
}

export type ProfileMenuOption = {
  value: ProfileMenuOptionValue;
  hidden?: boolean;
  label: ReactNode;
  icon?: ReactNode;
  leftComponent?: ReactNode;
  onClick?: () => void;
};
